import { render, staticRenderFns } from "./RolesTablePage.vue?vue&type=template&id=82bcdbb2&scoped=true"
import script from "./RolesTablePage.vue?vue&type=script&lang=js"
export * from "./RolesTablePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82bcdbb2",
  null
  
)

export default component.exports